import React from 'react'
import Svg from './Svg'
export const SvgEnforcementActions = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M23.677 21.463L10.817 9.757l.599-.6c.49-.491.754-1.126.795-1.772.023-.011.047-.021.069-.034l2.414-1.51a1.016 1.016 0 00-.054-1.348L10.442.283A1.008 1.008 0 009.098.23L7.592 2.65a1.51 1.51 0 00-.034.07 2.733 2.733 0 00-1.767.797l-2.283 2.29a2.743 2.743 0 00-.795 1.773.75.75 0 00-.07.033L.229 9.123c-.327.384-.303.991.053 1.348l4.199 4.21c.356.357.961.381 1.344.053l1.505-2.42a.644.644 0 00.034-.07 2.729 2.729 0 001.767-.797l.663-.666 11.675 12.894c.339.374.861.434 1.16.134l1.18-1.184c.3-.3.24-.823-.133-1.162z" />
  </Svg>
))
SvgEnforcementActions.isIcon = true
export default SvgEnforcementActions
